import React, { SVGProps } from "react";

const SVGDataInfo = (props: SVGProps<any>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4008_6285)">
        <g clipPath="url(#clip1_4008_6285)">
          <path
            d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4ZM11.99 10C12.548 10 13 10.452 13 11.01V16.134C13.1906 16.2441 13.3396 16.414 13.4238 16.6173C13.5081 16.8207 13.5229 17.0462 13.4659 17.2588C13.4089 17.4714 13.2834 17.6593 13.1087 17.7933C12.9341 17.9273 12.7201 18 12.5 18H12.01C11.8774 18 11.746 17.9739 11.6235 17.9231C11.501 17.8724 11.3896 17.798 11.2958 17.7042C11.202 17.6104 11.1276 17.499 11.0769 17.3765C11.0261 17.254 11 17.1226 11 16.99V12C10.7348 12 10.4804 11.8946 10.2929 11.7071C10.1054 11.5196 10 11.2652 10 11C10 10.7348 10.1054 10.4804 10.2929 10.2929C10.4804 10.1054 10.7348 10 11 10H11.99ZM12 7C12.2652 7 12.5196 7.10536 12.7071 7.29289C12.8946 7.48043 13 7.73478 13 8C13 8.26522 12.8946 8.51957 12.7071 8.70711C12.5196 8.89464 12.2652 9 12 9C11.7348 9 11.4804 8.89464 11.2929 8.70711C11.1054 8.51957 11 8.26522 11 8C11 7.73478 11.1054 7.48043 11.2929 7.29289C11.4804 7.10536 11.7348 7 12 7Z"
            fill="#0076CE"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4008_6285">
          <rect width="24" height="24" fill="white" />
        </clipPath>
        <clipPath id="clip1_4008_6285">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SVGDataInfo;
